import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark text-light py-4">
            <div className="container text-center">

                <div>
                    <a href="https://www.facebook.com" className="text-light mx-3" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.twitter.com" className="text-light mx-3" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.instagram.com" className="text-light mx-3" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram"></i>
                    </a>
                </div>
                {/* Footer Text */}
                <p>© 2025 Prakash Institute of Education | All Rights Reserved</p>



                {/* Social Media Icons */}

            </div>
        </footer>
    );
}

export default Footer;
